import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../services/lookup.service';
import { Observable, of } from 'rxjs';
import { LookupItem } from '../models/lookup-item';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'lookup'
})
export class LookupPipe implements PipeTransform {

  constructor(private lookupService: LookupService) {}

  transform(value: number | number[], lookupName: string | null): Observable<any> {
    const lookupAccessor = (lookup: LookupItem) => lookup.name;
    lookupName = this.lookupService.getDefaultLookupName(lookupName);

    if (!value || !lookupName) {
      return of(null);
    }

    return this.lookupService.getLookups(lookupName, value)
      .pipe(
        map(lookups => {
          if (Array.isArray(lookups)) {
            return lookups.filter(lookup => {
              if (typeof value === 'number') {
                return value === lookup.id;
              } else {
                return value.includes(lookup.id);
              }
            }).map(filtered => lookupAccessor(filtered))
              .join(', ');
          } else {
            return lookupAccessor(lookups);
          }
        })
      );
  }
}
